// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3IfOh","alertIcon":"ConfirmModal_alertIcon__GmwBf"};